import React from "react";
import { Breadcrumb, Card, Collapse, Divider, Table, Modal } from "antd";
import {
  InputNumber,
  Radio,
  Spin,
  DatePicker,
  Rate,
  Slider,
  Switch,
  message,
  Upload,
} from "antd";
import {
  AutoComplete,
  Button,
  Cascader,
  Checkbox,
  Col,
  Form,
  Icon,
  Input,
  Row,
  Select,
  Tooltip,
  formLayout,
} from "antd";
import { MenuService, OptionService } from "../../services";
import moment from "moment";
import { connect } from "react-redux";
import IntlMessages from "util/IntlMessages";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import arrayMove from "array-move";
import "../../../src/routes/components/dataDisplay/Collapse/basic.less";
import "../../../src/routes/components/dataEntry/Form/otherFormControls.less";
// ---------------drag sorting
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import DraggableBodyRow from "../menuList/menuInfo/DraggableBodyRow";
// ---------------drag sorting
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import MenuOutline from "@ant-design/icons/MenuOutlined";
// Switch script start
function onChange(checked) {
  console.log(`switch to ${checked}`);
}
// Switch script start

const { RangePicker } = DatePicker;
// search-script
const Search = Input.Search;
const { confirm } = Modal;

// search-script-end

const FormItem = Form.Item;
const Option = Select.Option;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

// import "./basic.less";

const Panel = Collapse.Panel;

// const text = `
//   A dog is a type of domesticated animal.
//   Known for its loyalty and faithfulness,
//   it can be found as a welcome guest in many households across the world.
// `;
const callback = (key) => {
  console.log(key);
};

const DragHandle = sortableHandle(() => (
  <MenuOutline style={{ cursor: "pointer", color: "#999" }} />
));
// const Basic = () => {

// };

const columns = [
  {
  title: "Sort",
  dataIndex: "sort",
  width: 30,
  className: "drag-visible",
  render: () => <DragHandle />,
},
  {
    title: <IntlMessages id="option.optionName" />,
    dataIndex: "optionName",
    className: "drag-visible",
    key: "optionName",
    
  },
  {
    title: <IntlMessages id="option.type" />,
    dataIndex: "type",
    className: "drag-visible",
    key: "type",
  },
  {
    title: <IntlMessages id="option.primary" />,
    dataIndex: "primary",
    className: "drag-visible",
    key: "primary",
  },
  {
    title: "Status",
    dataIndex: "status",
    className: "drag-visible",
    key: "status",
  },
  {
    title: <IntlMessages id="option.action" />,
    dataIndex: "action",
    className: "drag-visible",
    key: "action",
  },
];

// AddOption-tabile
const columnsAddOption = [
  {
    title: "Items",
    dataIndex: "items",
    key: "items",
  },
  {
    title: "Price(Excl Of Tax)",
    dataIndex: "priceExcl",
    key: "priceExcl",
  },
];

const dataAddOption = [
  {
    key: "1",
    items: "Olives",
    priceExcl: "5",
  },
  {
    key: "2",
    items: "Onion",
    priceExcl: "5",
  },
  {
    key: "3",
    items: "Tomamtos",
    priceExcl: "5",
  },
];
// AddOption-tabile-end

// AddMultiOption-tabile
const columnsAddMultiOption = [
  {
    title: "Items",
    dataIndex: "items",
    key: "items",
  },
  {
    title: "Min",
    dataIndex: "min",
    key: "min",
  },
  {
    title: "Max",
    dataIndex: "max",
    key: "max",
  },
  {
    title: "Price(Excl Of Tax)",
    dataIndex: "priceExcl",
    key: "priceExcl",
  },
];

const dataAddMultiOption = [
  {
    key: "1",
    items: "Coke",
    min: "5",
    max: "5",
    priceExcl: "10",
  },
  {
    key: "2",
    items: "Sprinte",
    min: "5",
    max: "10",
    priceExcl: "10",
  },
  {
    key: "3",
    items: "Fanta",
    min: "5",
    max: "10",
    priceExcl: "10",
  },
];

const SortableItem = sortableElement((props) => <tr {...props} />);
const SortableContainer = sortableContainer((props) => <tbody {...props} />);
const DragableBodyRow = ({ index, className, style, ...restProps }) => (
  <SortableItem index={restProps["data-row-key"]} {...restProps} />
);
// AddMultiOption-tabile-end

//   upload-script start
const props = {
  name: "file",
  action: "//jsonplaceholder.typicode.com/posts/",
  headers: {
    authorization: "authorization-text",
  },
  onChange(info) {
    if (info.file.status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === "done") {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};
//   upload-script end

class optionList extends React.Component {
  // form-scripts start
  handleFormLayoutChange = (e) => {
    this.setState({ formLayout: e.target.value });
  };

  constructor() {
    super();
    this.state = {
      search: "",
      isPrimary: undefined,
      type: 0,
      startTimeStamp: 0,
      endTimeStamp: 0,
      optionList: [],
      optionsList: [],
      spin: false,
      formLayout: "horizontal",
      visible: false,
      addItem: false,
      addOption: false,
    };
  }

  // --------- drag sorting (same pattern as `menuList/index.js`)
  components = {
    body: {
      row: DraggableBodyRow,
    },
  };

  onRow = (record, index) => ({
    index,
    moveRow: this.moveRow,
  });

  moveRow = (dragIndex, hoverIndex) => {
    const dataSource = this.state.optionsList;
    console.log("before", this.state.optionsList);

    if (dragIndex !== hoverIndex) {
      const newData = arrayMove(
        [].concat(dataSource),
        dragIndex,
        hoverIndex
      ).filter((el) => !!el);

      this.setState({
        optionsList: newData,
      });

      console.log("after", this.state.optionsList);
    }
  };
  saveSortedList = async () => {
    const itemList = this.state.optionsList;
    let sortedList = [];
    console.log("itemList", itemList);
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i].Id) {
        sortedList.push({
          OptionId: itemList[i].Id,
          SortOrder: i,
        });
      }
    }

    console.log("sortedList", sortedList);
    if (sortedList.length === 0) {
      message.error("No items to sort");
      return;
    }

    const sortedData = {
      menuOptionItems: sortedList
    };
  
    this.setState({ spinForItem: true });
    try {
      const response = await MenuService.updateOptionListSorting(sortedData);
      
      if (response && response.Success) {
        message.success("Sorted List Successfully Updated");
      } else {
        message.error(response.APIMessage || "Failed to update sorted list");
      }
    } catch (error) {
      message.error("Error updating sorted list");
    } finally {
      this.setState({ spinForItem: false });
    }
  };
  
  fetchMoreData = async (e) => {
    this.setState({
      loading: true,
    });
    const searchQuery = "";
    const pageSize = 15;
    const pageNo = this.state.pageNo + 1;
    const response = await OptionService.getAllOptionsList(
      searchQuery,
      pageSize,
      pageNo
    ); //isAvailable

    if (response.length == 0) {
      message.warning("End!");
      this.setState({
        hasMore: false,
        loading: false,
      });
      return;
    }

    let optionList = [];
    for (let i = 0; i < response.length; i++) {
      optionList.push({
        key: i,
        optionName: response[i].Name,
        type:
          response[i].Type == 1 ? (
            <IntlMessages id="option.singleSelection" />
          ) : (
            <IntlMessages id="option.multiSelection" />
          ),
        primary: response[i].IsPrimary ? (
          <IntlMessages id="option.yes" />
        ) : (
          <IntlMessages id="option.no" />
        ),
        status: (
          <Switch
            defaultChecked={response[i].IsAvailable}
            onChange={(value) => this.updateOptionStatus(value, response[i].Id)}
          />
        ),
        action: (
          <a className="action-btn">
            <i
              onClick={() =>
                this.openMenuInfo(
                  response[i].Id,
                  response[i].Name,
                  response[i].IsPrimary,
                  response[i].IsAvailable,
                  response[i].MaxSelectable,
                  response[i].OptionItems,
                  response[i].Type
                )
              }
              className="fa fa-pencil"
            ></i>
            <i
              onClick={() => this.deleteOption(response[i].Id)}
              style={{ paddingLeft: "20px" }}
              class="fa fa-trash"
            ></i>
          </a>
        ),
      });
    }

    let mergeList = [...this.state.data, ...optionList];
    this.setState({
      data: mergeList,
      listData: mergeList,
      pageNo: this.state.pageNo + 1,
      loading: false,
    });
  };

  createOptionListing = (response) => {
    let optionList = [];
    for (let i = 0; i < response.length; i++) {
      optionList.push({
        key: i,
        optionName: response[i].Name,
        type:
          response[i].Type == 1 ? (
            <IntlMessages id="option.singleSelection" />
          ) : (
            <IntlMessages id="option.multiSelection" />
          ),
        primary: response[i].IsPrimary ? (
          <IntlMessages id="option.yes" />
        ) : (
          <IntlMessages id="option.no" />
        ),
        status: (
          <Switch
            defaultChecked={response[i].IsAvailable}
            onChange={(value) => this.updateOptionStatus(value, response[i].Id)}
          />
        ),
        action: (
          <a className="action-btn">
            <i
              onClick={() =>
                this.openMenuInfo(
                  response[i].Id,
                  response[i].Name,
                  response[i].IsPrimary,
                  response[i].IsAvailable,
                  response[i].MaxSelectable,
                  response[i].OptionItems,
                  response[i].Type
                )
              }
              className="fa fa-pencil"
            ></i>
            <i
              onClick={() => this.deleteOption(response[i].Id)}
              style={{ paddingLeft: "20px" }}
              class="fa fa-trash"
            ></i>
          </a>
        ),
      });
    }

    this.setState({
      optionList: optionList,
      spin: false,
    });
  };

  async componentDidMount() {
    this.setState({ spin: true });
    const body = {
      SearchQuery: "",
      PageSize: 0,
      PageNo: 0,
    };
    const response = await OptionService.getAllOptionsList(body);
    this.setState({ optionsList: response, spin: false });
  }

  updateOptionStatus = async (value, optionId, i) => {
    var ot = this.state.optionsList;
    ot[i].SwitchLoading = true;
    this.setState({ optionsList: ot });

    const optionInfo = {
      OptionId: optionId,
      OptionItemId: null,
      IsAvailable: value,
    };
    const response = await OptionService.updateOptionStatus(optionInfo);
    if (response && response.Success) {
      ot[i].IsAvailable = value;
      message.success("Status Changed!");
    } else if (response.APICode == 14) {
      ot[i].IsAvailable = true;
      Modal.error({
        title: response.APIMessage,
        content: (
          <span>
            Here is the associated list.{" "}
            <ul>
              {response.Data.map((v) => (
                <li>{v.Name}</li>
              ))}
            </ul>
          </span>
        ),
      });
    } else if (response.APICode == 114) {
      ot[i].IsAvailable = true;
      Modal.error({
        title: response.APIMessage,
        content: (
          <span>
            Here is the associated menu item list.{" "}
            <ul>
              {response.Data.map((v) => (
                <li>{v.Name}</li>
              ))}
            </ul>
          </span>
        ),
      });
    } else {
      message.error("Failed!");
    }

    ot[i].SwitchLoading = false;
    this.setState({ optionsList: ot, spin: false });
  };

  deleteOption = async (optionId) => {
    const _this = this;
    const optionInfo = {
      OptionId: optionId,
    };

    confirm({
      title: "Do you really want to delete this?",
      icon: <ExclamationCircleOutlined />,
      content: "Click!",
      onOk() {
        console.log("OK");
        _this.deleteApi(optionInfo);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  deleteApi = async (optionInfo) => {
    this.setState({ spin: true });
    const body = {
      SearchQuery: "",
      PageSize: 0,
      PageNo: 0,
    };

    const response = await OptionService.deleteOption(optionInfo);
    if (response && response.Success) {
      message.success("Option Deleted!");
    } else if (response && !response.Success && response.APICode == 14) {
      Modal.error({
        title: response.APIMessage,
        content: (
          <span>
            Here is the associated list.{" "}
            <ul>
              {response.Data.map((v) => (
                <li>{v.Name}</li>
              ))}
            </ul>
          </span>
        ),
      });
    } else if (response.APICode == 114) {
      Modal.error({
        title: response.APIMessage,
        content: (
          <span>
            Here is the associated menu item list.{" "}
            <ul>
              {response.Data.map((v) => (
                <li>{v.Name}</li>
              ))}
            </ul>
          </span>
        ),
      });
    } else {
      message.error("Failed!");
    }

    const rs = await OptionService.getAllOptionsList(body);
    this.setState({ optionsList: rs, spin: false });
  };

  searchHandler = async (searchInput) => {
    this.setState(
      {
        search: searchInput,
      },
      () => {
        this.handleFilter();
      }
    );
  };

  primaryFilter = (e) => {
    this.setState(
      {
        isPrimary: e.target.checked,
      },
      () => {
        this.handleFilter();
      }
    );
  };

  rangeFilter = (value) => {
    let start = value.length && moment(value[0]._d).unix();
    let end = value.length && moment(value[1]._d).unix();
    this.setState(
      {
        startTimeStamp: start,
        endTimeStamp: end,
      },
      () => {
        this.handleFilter();
      }
    );
  };

  searchReset = async (searchInput) => {
    if (searchInput.target.value == "") {
      this.setState({
        search: "",
      });
      const body = {
        SearchQuery: "",
        PageSize: 0,
        PageNo: 0,
      };

      const response = await OptionService.getAllOptionsList(body);
      this.setState({ optionsList: response, spin: false });
    } else {
      this.setState({
        search: searchInput.target.value,
      });
    }
  };

  handleIsAvailable = (value) => {
    this.setState(
      {
        type: value,
      },
      () => {
        this.handleFilter();
      }
    );
  };

  handleFilter = async () => {
    this.setState({ spin: true });
    let { search, isPrimary, type, startTimeStamp, endTimeStamp } = this.state;

    const body = {
      SearchQuery: search,
      PageSize: 0,
      PageNo: 0,
      IsPrimaryOption: isPrimary,
      OptionType: type,
      StartTimeStamp: startTimeStamp,
      EndTimeStamp: endTimeStamp,
    };

    Object.keys(body).forEach((key) =>
      body[key] === undefined ? delete body[key] : {}
    );

    const response = await OptionService.getAllOptionsList(body);
    this.setState({
      optionsList: response,
      spin: false,
    });
  };

  openMenuInfo = (
    id,
    name,
    isPrimary,
    isAvailable,
    maxSelectable,
    optionItems,
    type
  ) => {
    this.props.history.push({
      pathname: type == 1 ? "/optionAddSingal" : "OptionAddMulty",
      info: {
        optionId: id,
        name: name,
        isPrimary: isPrimary,
        isAvailable: isAvailable,
        maxSelectable: maxSelectable,
        optionItems: optionItems,
      },
    });
  };

  clearFilter = async () => {
    this.setState({ spin: true });
    const body = {
      SearchQuery: "",
      PageSize: 0,
      PageNo: 0,
    };
    const response = await OptionService.getAllOptionsList(body);
    this.setState({
      optionsList: response,
      spin: false,
      search: "",
      type: 0,
      startTimeStamp: 0,
      endTimeStamp: 0,
      isPrimary: false,
    });
  };

  // form-scripts end
  // Modal-scripts start
  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  addItem = (e) => {
    this.setState({
      addItem: !this.state.addItem,
    });
  };
  addOption = (e) => {
    this.setState({
      addOption: !this.state.addOption,
    });
  };
  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  // Modal-scripts end
  render() {
    //   const {getFieldDecorator} = this.props.form;
    // const formItemLayout = {
    //   labelCol: {xs: 24, sm: 6},
    //   wrapperCol: {xs: 24, sm: 14},
    // };
    // form-scripts start
    const DraggableContainer = (props) => {
      return (
        <SortableContainer
          useDragHandle
          helperClass="row-dragging"
          onSortEnd={({ oldIndex, newIndex }) => {
            this.onSortEnd({ oldIndex, newIndex });
          }}
          {...props}
        />
      );
    };
    const { formLayout } = this.state;
    const formItemLayout =
      formLayout === "horizontal"
        ? {
            labelCol: { xs: 24, sm: 6 },
            wrapperCol: { xs: 24, sm: 16 },
          }
        : null;
    const buttonItemLayout =
      formLayout === "horizontal"
        ? {
            wrapperCol: { xs: 24, sm: { span: 14, offset: 6 } },
          }
        : null;
    // form-scripts end

    // MULTIPLE-scripts start
    const children = [];
    for (let i = 1; i < 10; i++) {
      children.push(<Option key={i.toString(36) + i}>{"test"}</Option>);
    }
    function handleChange(value) {
      console.log(`selected ${value}`);
    }
    // MULTIPLE-scripts End

    const optionsList = this.state.optionsList.map((v, i) => {
      return {
        // Use a stable key so antd + drag/drop behave correctly
        key: v.Id,
        Id: v.Id,
        optionName: v.Name,
        type:
          v.Type == 1 ? (
            <IntlMessages id="option.singleSelection" />
          ) : (
            <IntlMessages id="option.multiSelection" />
          ),
        primary: v.IsPrimary ? (
          <IntlMessages id="option.yes" />
        ) : (
          <IntlMessages id="option.no" />
        ),
        status: (
          <Switch
            loading={v.SwitchLoading == true}
            checked={v.IsAvailable}
            onClick={(value) => this.updateOptionStatus(value, v.Id, i)}
          />
        ),
        action: (
          <a className="action-btn">
            <i
              onClick={() =>
                this.openMenuInfo(
                  v.Id,
                  v.Name,
                  v.IsPrimary,
                  v.IsAvailable,
                  v.MaxSelectable,
                  v.OptionItems,
                  v.Type
                )
              }
              className="fa fa-pencil"
            ></i>
            <i
              onClick={() => this.deleteOption(v.Id)}
              style={{ marginLeft: "20px" }}
              class="fa fa-trash"
            ></i>
          </a>
        ),
      };
    });

    return (
      <div className="menu-editor-box card-pad-new menu-cate-list option-list option-list-vh">
        <div className="ant-row margin-btm-20 d-none">
          <div className="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24">
            <div className="Breadcrumb-inner-box menu-ed">
              <Breadcrumb>
                <Breadcrumb.Item>Menu</Breadcrumb.Item>
                <Breadcrumb.Item>
                  Thai House Wok - Folkungagatan
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <span className="gx-link">View on Delivery Pizza.com</span>
                </Breadcrumb.Item>
              </Breadcrumb>
              <div className="icon-more">
                <i class="icon icon-ellipse-h"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="payout-report-box">
          <Card className="gx-card breadcrumb-box" title="">
            <div className="Breadcrumb-inner-box d-none">
              <Breadcrumb>
                <Breadcrumb.Item>Payout reports</Breadcrumb.Item>
                <Breadcrumb.Item>
                  Thai House Wok - Folkungagatan
                </Breadcrumb.Item>
                {/* <Breadcrumb.Item><span className="gx-link">View on Delivery Pizza.com</span></Breadcrumb.Item> */}
              </Breadcrumb>
              {/* <div className="icon-more"><i class="icon icon-ellipse-h"></i></div> */}
            </div>
            <div className="collaps-main">
  <div className="ant-row">
    {/* Search Box */}
    <div className="ant-col ant-col-xs-24 ant-col-sm-8 ant-col-md-6 gx-mb-3">
      <IntlMessages id="option.search">
        {(text) => (
          <Search
            placeholder={text}
            onSearch={(value) => this.searchHandler(value)}
            onChange={(value) => this.searchReset(value)}
            style={{ width: '100%' }}
            value={this.state.search}
          />
        )}
      </IntlMessages>
    </div>

    {/* Primary Checkbox */}
    <div className="ant-col ant-col-xs-24 ant-col-sm-4 ant-col-md-3 gx-mb-3">
      <Checkbox
        onChange={(e) => this.primaryFilter(e)}
        checked={this.state.isPrimary}
      >
        <IntlMessages id="option.primary" />
      </Checkbox>
    </div>

    {/* Date Range Picker */}
    <div className="ant-col ant-col-xs-24 ant-col-sm-8 ant-col-md-6 gx-mb-3">
      <RangePicker
        onChange={(value) => this.rangeFilter(value)}
        format={this.props.whitelisting.AdminDateFormat}
        style={{ width: '100%' }}
      />
    </div>

    {/* Type Filter Dropdown */}
    <div className="ant-col ant-col-xs-24 ant-col-sm-6 ant-col-md-4 gx-mb-3">
      <Select
        className="select-box"
        onChange={(value) => this.handleIsAvailable(value)}
        style={{ width: '100%' }}
        value={this.state.type}
      >
        <Option value={0}>
          <IntlMessages id="option.allSelection" />
        </Option>
        <Option value={1}>
          <IntlMessages id="option.singleSelection" />
        </Option>
        <Option value={2}>
          <IntlMessages id="option.multiSelection" />
        </Option>
      </Select>
    </div>

    {/* Reset Button */}
    <div className="ant-col ant-col-xs-24 ant-col-sm-4 ant-col-md-2 gx-mb-3">
      <Button
        onClick={(e) => this.clearFilter(e)}
        type="primary"
        style={{ width: '100%' }}
      >
        <IntlMessages id="option.reset" />
      </Button>
    </div>

    {/* Add Button */}
    <div className="ant-col ant-col-xs-24 ant-col-sm-6 ant-col-md-2 gx-mb-3">
      <Button
        onClick={() => {
          this.props.history.push("optionAddSingal");
        }}
        type="primary"
        style={{ width: '100%' }}
      >
        <i className="icon icon-add"></i>
        <IntlMessages id="option.add" />
      </Button>
    </div>

    {/* Save Sorted List Button */}
    <div className="ant-col ant-col-xs-24 ant-col-sm-6 ant-col-md-3 gx-mb-3">
      <Button
        onClick={() => {
          this.saveSortedList();
        }}
        type="primary"
        style={{ width: '100%' }}
      >
        <i className="fa fa-floppy-o"></i>
        <IntlMessages id="menuList.saveSortedList" />
      </Button>
    </div>
  </div>

  {/* Table Section */}
  <div className="ant-row">
    <div className="ant-col ant-col-xs-24">
      {this.state.spin ? (
        <Spin
          style={{ margin: '50px auto', display: 'block' }}
          size="large"
          tip="Loading..."
        />
      ) : (
        <Table
          className="gx-table-responsive payout-report menu-cate-lisi-table"
          columns={columns}
          dataSource={optionsList}
          rowKey="Id"
          components={this.components}
          onRow={this.onRow}
          pagination={false}
        />
      )}
    </div>
  </div>
</div>
          </Card>
        </div>
        <div className="payout-report-box option-add-box d-none">
          <Card className="gx-card breadcrumb-box" title="">
            <div>
              <div className="title-sub">
                <h2>Options</h2>
                <hr className="hr-line"></hr>
              </div>
              <div class="ant-row Platform-Charges">
                <div class="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 platform-charges-lft">
                  <div className="detail-res-lft">
                    <div class="ant-row charge-form">
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Type :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-6 gx-mb-3">
                        <Select
                          className=""
                          defaultValue="Select-1"
                          onChange={handleChange}
                        >
                          <Option value="Select-1">
                            Single Selection Option
                          </Option>
                          <Option value="Select-2">
                            Multi Selection Option
                          </Option>
                        </Select>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Disable/Enable :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-6 gx-mb-3">
                        <Switch defaultChecked onChange={onChange} />
                      </div>
                    </div>
                    <div class="ant-row charge-form op-cnter">
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Name :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-6 gx-mb-3">
                        <Input placeholder="Topping" />
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <Checkbox>Primary</Checkbox>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Max Selectable :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-2 gx-mb-3">
                        <Input
                          className="input-number"
                          type="number"
                          placeholder="0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="title-sub">
                <h2>Add Option Details</h2>
                <hr className="hr-line"></hr>
              </div>
              <div class="ant-row Platform-Charges">
                <div class="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 platform-charges-lft">
                  <div className="detail-res-lft">
                    <div class="ant-row charge-form op-cnter">
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Item Name :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-6 gx-mb-3">
                        <Input placeholder="Olives" />
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-2 gx-mb-3 charge-lable">
                        <label>Price :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-6 gx-mb-3">
                        <Input type="text" placeholder="5" />
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-6 gx-mb-3 add-btn-rite">
                        <button
                          type="button"
                          class="ant-btn color-white ant-btn-primary"
                        >
                          <i class="icon icon-add"></i>
                          <span> Add</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="title-sub">
                <h2>Option Details</h2>
                <hr className="hr-line"></hr>
              </div>
              <Table
                className="gx-table-responsive user-manage-tabile"
                columns={columnsAddOption}
                dataSource={dataAddOption}
                rowKey="index"
                components={this.components}
                onRow={this.onRow}
              />
              <div class="ant-row Platform-Charges delivery-charges">
                <div class="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 platform-charges-lft">
                  <div className="detail-res-lft"></div>
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div className="payout-report-box option-add-multi-box d-none">
          <Card className="gx-card breadcrumb-box" title="">
            <div>
              <div className="title-sub">
                <h2>Options</h2>
                <hr className="hr-line"></hr>
              </div>
              <div class="ant-row Platform-Charges">
                <div class="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 platform-charges-lft">
                  <div className="detail-res-lft">
                    <div class="ant-row charge-form">
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Type :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-6 gx-mb-3">
                        <Select
                          className=""
                          defaultValue="Select-2"
                          onChange={handleChange}
                        >
                          <Option value="Select-1">
                            Single Selection Option
                          </Option>
                          <Option value="Select-2">
                            Multi Selection Option
                          </Option>
                        </Select>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Disable/Enable :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-6 gx-mb-3">
                        <Switch defaultChecked onChange={onChange} />
                      </div>
                    </div>
                    <div class="ant-row charge-form op-cnter">
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Name :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-6 gx-mb-3">
                        <Input placeholder="Drinks" />
                      </div>
                      {/*<div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                      <Checkbox>Primary</Checkbox>
                      </div>*/}
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Max Selectable :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-2 gx-mb-3">
                        <Input
                          className="input-number"
                          type="number"
                          placeholder="0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="title-sub">
                <h2>Add Option Details</h2>
                <hr className="hr-line"></hr>
              </div>
              <div class="ant-row Platform-Charges">
                <div class="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 platform-charges-lft">
                  <div className="detail-res-lft">
                    <div class="ant-row charge-form op-cnter">
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Item Name :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-6 gx-mb-3">
                        <Input placeholder="Fanta" />
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Minimum Quantity :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-2 gx-mb-3">
                        <Input
                          className="input-number"
                          type="number"
                          placeholder="5"
                        />
                      </div>
                    </div>
                    <div class="ant-row charge-form op-cnter">
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Price :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-6 gx-mb-3">
                        <Input placeholder="5" />
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                        <label>Max Quantity :</label>
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-2 gx-mb-3">
                        <Input
                          className="input-number"
                          type="number"
                          placeholder="7"
                        />
                      </div>
                      <div class="ant-col ant-col-xs-24 ant-col-sm-8 gx-mb-3 add-btn-rite">
                        <button
                          type="button"
                          class="ant-btn color-white ant-btn-primary"
                        >
                          <i class="icon icon-add"></i>
                          <span> Add</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="title-sub">
                <h2>Option Details</h2>
                <hr className="hr-line"></hr>
              </div>
              <Table
                className="gx-table-responsive user-manage-tabile"
                columns={columnsAddMultiOption}
                dataSource={dataAddMultiOption}
              />
              <div class="ant-row Platform-Charges delivery-charges">
                <div class="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 platform-charges-lft">
                  <div className="detail-res-lft"></div>
                </div>
              </div>
            </div>
          </Card>
        </div>

        <Modal
          title="Add Category"
          visible={this.state.addItem}
          onOk={this.addItem}
          onCancel={this.addItem}
        >
          <div className="item-detail-edit-box">
            {/* <p>Some contents...</p> */}
            <Form layout={formLayout}>
              <FormItem label="Category Name" {...formItemLayout}>
                <Input placeholder="" />
              </FormItem>
              {/* <FormItem
                                label="Price"
                                {...formItemLayout}
                            >
                                <Input placeholder=""/>
                           </FormItem>*/}
              <FormItem label="Image" {...formItemLayout}>
                <Upload {...props}>
                  <Button className="btn-upload-cust">
                    <Icon type="upload" /> Upload
                  </Button>
                </Upload>
                {/* <Input placeholder=""/> */}
              </FormItem>
            </Form>
          </div>
        </Modal>
        {/* modal-edit-end */}

        {/* modal-edit */}
        <Modal
          title="Add Category"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <div className="item-detail-edit-box">
            {/* <p>Some contents...</p> */}
            <Form layout={formLayout}>
              <FormItem label="Category name" {...formItemLayout}>
                <Input placeholder="" />
              </FormItem>
            </Form>
          </div>
        </Modal>
        {/* modal-add-option */}

        <Modal
          title="Add a new option"
          visible={this.state.addOption}
          onOk={this.addOption}
          onCancel={this.addOption}
        >
          <div className="item-detail-edit-box">
            <p>Option Details</p>
            <Form layout={formLayout}>
              <FormItem label="Optin type" {...formItemLayout}>
                {/* <Input placeholder=""/> */}
              </FormItem>
              <FormItem label="Name" {...formItemLayout}>
                <Input placeholder="" />
              </FormItem>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  whitelisting: state.settings.whitelisting,
});
export default DragDropContext(HTML5Backend)(connect(mapStateToProps)(optionList));

// NOTE: `option/index.js` should only export `optionList`.
// If you need drag-and-drop in this screen, implement it on `optionList`
// (similar to `src/routes/menuList/index.js`). The `DragDropContext(menuList)`
// export that was here caused "multiple default exports" and referenced the
// wrong component.

// (Removed accidental extra default export that belonged to `menuList/index.js`.)
